import { Navigate } from "react-router-dom";

const RestrictDirected = ({ children }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (!user) return children;
  const isSelfDirected = !user.is_self_pay;

  return isSelfDirected ? <Navigate to="/*" replace /> : children;
};

export default RestrictDirected;
